import React from 'react'
import PageHeader from '../components/PageHeader';
import VisaAssistanceSection from '../components/VisaAssistanceSection';
import VisaTabs from '../components/VisaTabs';

const Visas = () => {
    return (
        <>

            <PageHeader
                title="Visa"
                image="img/visa-1.png" // Use your own path
                breadcrumbs={[
                    { label: "Visa", active: true },
                ]}
            />
            <VisaAssistanceSection />
            <VisaTabs />

        </>

    )
}

export default Visas